import * as React from "react";
import { Helmet } from "react-helmet";
import HubspotForm from "react-hubspot-form";
import NavBar from "../templates/navbar";
import HeroImage from "./../images/homePage/hero-img.png";
import SegmentationIcon from "./../images/icons/customer-attribute.svg";
import BlogsPreview from "./../templates/blogsPreview";

// Import Icons
import GrowthIcon from "./../images/icons/growth.svg";
import AutomationIcon from "./../images/icons/journey.svg";
import CallToAction from "./../templates/callToAction";
import EnterPriseFeaturesSection from "./../templates/enterpriseFeaturesSection";
import FooterSection from "./../templates/footer";

// Client Logos
import AndMeIcon from "./../images/customer-logos/andme.webp";
import FemellaIcon from "./../images/customer-logos/femella.avif";
import ISayOrganicIcon from "./../images/customer-logos/isayorganic.avif";
import KanelleIcon from "./../images/customer-logos/kanelle.png";
import NesteryIcon from "./../images/customer-logos/nestery.webp";
import SleepyOwlIcon from "./../images/customer-logos/sleepy-owl.avif";

const heroBackgroundColor = "#fffaf0";

const info = {
  allFeatures: [
    {
      icon: GrowthIcon,
      title: "Grow Your Customer List",
      description: "Grow your email and SMS list with Popups, Flyouts and other high-converting displays.",
    },
    {
      icon: AutomationIcon,
      title: "Cross-channel Automation",
      description: "Drive more revenue with multi-channel automation built for e-commerce, with ready made automation templates.",
    },
    {
      icon: SegmentationIcon,
      title: "Advanced Segments & Reports",
      description: "Drive action from your consumers at each stage of their lifecycle.",
    },
  ],
  journeyFeatures: [
    {
      id: "abc",
      title: "Send messages on multiple channels",
      description: "Send personalised and contextual messages via Email, SMS, WhatsApp, Push Notifications & many other channels.",
    },
    {
      id: "def",
      title: "Pre-built workflow templates",
      description: "Use high-converting pre-made automations built for e-commerce to get started quickly.",
    },
    {
      id: "ghi",
      title: "Advanced automation reports",
      description: "Measure performance and revenue generted by the workflow. See live view how user moving along in different steps of workflow. Identify the dropouts and revenue loss and optimize workflows further. ",
    },
  ],
};

const brandsToShowDesktop = [FemellaIcon, AndMeIcon, SleepyOwlIcon, ISayOrganicIcon, KanelleIcon, NesteryIcon];
const brandsToShowMobile = [""];

const IndexPage = () => {
  return (
    <main style={{ backgroundColor: heroBackgroundColor }}>
      <Helmet>
        <meta charset="utf-8" />
        <meta name="description" content="Get Demo" />
        <meta property="og:image" content={HeroImage} />
        <meta name="google" content="nositelinkssearchbox" />
        <title>Growlytics | Schedule Demo</title>
        <link rel="canonical" href="/" />
      </Helmet>

      <NavBar bg={heroBackgroundColor}></NavBar>

      {/* Hero Section */}
      <div className="relative max-w-7xl mx-auto overflow-hidden heroSection">
        <div className="hidden lg:block lg:absolute lg:inset-0" aria-hidden="true">
          <svg className="absolute top-0 left-1/2 transform translate-x-64 -translate-y-8" width={640} height={784} fill="none" viewBox="0 0 640 784">
            <defs>
              <pattern id="9ebea6f4-a1f5-4d96-8c4e-4c2abf658047" x={118} y={0} width={20} height={20} patternUnits="userSpaceOnUse">
                <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="orange" />
              </pattern>
            </defs>
            <rect y={72} width={640} height={640} className="text-gray-50" />
            <rect x={118} width={404} height={784} fill="url(#9ebea6f4-a1f5-4d96-8c4e-4c2abf658047)" />
          </svg>
        </div>

        <div className="relative pt-0 md:pt-6 pb-8 md:pb-16 px-5 md:px-0">
          <main className="mt-12 md:mt-10">
            <div className="mx-auto max-w-7xl">
              <div className="lg:grid lg:grid-cols-12 lg:gap-2">
                <div className="sm:px-6 md:px-0 md:max-w-2xl md:mx-auto lg:col-span-7 sm:text-center lg:text-left lg:flex lg:items-center">
                  <div className="break-words text-gray-800 text-center md:text-left md:pr-20">
                    {/* For Desktop */}
                    <h1 class="hidden md:block">
                      <span className="mt-1 font-bold md:font-extrabold  md:text-5xl xl:text-10xl" style={{ "line-height": "60px" }}>
                        See why <br />
                        <span class="text-primary-600">1, 000+ brands </span>use
                        <br />
                        Growlytics to sell more!
                      </span>
                    </h1>
                    {/* For Desktop */}
                    <h1 class="block md:hidden">
                      <span className="mt-1 font-bold text-3xl leading-10">
                        See why <br />
                        <span class="text-primary-600">1, 000+ brands </span>use
                        <br />
                        Growlytics to sell more!
                      </span>
                    </h1>

                    {/* For Desktop */}
                    <div class="hidden md:block">
                      <p className={`mt-3 sm:mt-5 mb-10 md:mb-0 text-xl text-black sm:text-xl lg:text-xl xl:text-lg`} style={{ "line-height": "30px", "font-weight": "300", letterSpacing: "2px" }}>
                        Find out how Growlytics can help you communicate better with your customers and drive more revenue. Complete this form and someone on our team will follow up to see how we can help you.
                      </p>
                    </div>

                    {/* For Mobile */}
                    <div class="block md:hidden">
                      <p className={`mt-3 sm:mt-5 mb-10 md:mb-0 text-base text-black`} style={{ "font-weight": "300", letterSpacing: "2px" }}>
                        Find out how Growlytics can help you communicate better with your customers and drive more revenue. Complete this form and someone on our team will follow up to see how we can help you.
                      </p>
                    </div>

                    {/* Desktop Trusted By */}
                    <div className="hidden md:block">
                      <div class="grid grid-cols-3 gap-4 mt-6">
                        {brandsToShowDesktop.map((feature) => (
                          <div key={feature} style={{ textAlign: "center" }}>
                            <img className="h-10 mt-6 mx-auto" src={feature} />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-4 md:mt-16 lg:mt-0 lg:col-span-5">
                  <div class=" shadow overflow-hidden rounded-lg mr-0 md:mr-16">
                    <div class="px-4 py-5 sm:px-6  bg-gray-800 text-center">
                      <h3 class="text-2xl leading-6 font-medium text-white">Schedule Demo</h3>
                      {/* <p class="mt-1 max-w-2xl text-sm  text-white">Find out how Growlytics can help you communicate better with your customers.</p> */}
                    </div>
                    <div class="pl-5 border-t border-gray-200 px-4 py-5 sm:p-0 bg-gray-50">
                      <div class="ml-6 mt-6">
                        <HubspotForm portalId="6517607" formId="8f6b00c0-3dbf-459d-a699-8176c26c6320" onSubmit={() => console.log("Submit!")} onReady={(form) => console.log("Form ready!")} loading={<div>Loading...</div>} />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Mobile Trusted By */}
                <div className="block md:hidden mb-4 md:mb-0">
                  <div class="grid grid-cols-3 gap-4 mt-6">
                    {brandsToShowDesktop.map((feature) => (
                      <div key={feature} style={{ textAlign: "center" }}>
                        <img className="h-7 mt-4 mx-auto" src={feature} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>

      {/* <!-- All Features Section --> */}
      <div className="relative sm:mt-5 md:mt-20 bg-gray-50 pt-20 pb-20 sm:pb-50">
        <div className="text-center mb-5">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-badgecolor text-badgetextcolor">All-In-One Marketing & Engagement Platform</span>
        </div>
        <p className="mt-2 text-3xl px-5 font-bold text-gray-900 sm:text-4xl text-center">
          Get everything you need to <br className="hidden md:inline-block" />
          convert first time visitors to repeat buyers
        </p>
        <div className="max-w-xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 mt-20">
          <dl className="space-y-10 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-8 text-center md:text-left">
            {info.allFeatures.map((feature) => (
              <div key={feature.title}>
                <dt>
                  <div className="flex items-center justify-center align-items-center h-12 w-12 rounded-md bg-primary-600 text-white text-center m-auto md:ml-0 ">
                    <img src={feature.icon} className="h-10" />
                  </div>
                  <p className="mt-5 text-lg leading-6 font-medium text-gray-900">{feature.title}</p>
                </dt>
                <dd className="mt-2 text-base text-gray-500 ">{feature.description}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      {/* Enterprise Features */}
      <div class="bg-white">
        <EnterPriseFeaturesSection></EnterPriseFeaturesSection>
      </div>

      {/* Enterprise Features */}
      <CallToAction></CallToAction>

      {/* Blogs Preview */}
      <BlogsPreview></BlogsPreview>

      {/* Add Footer */}
      <FooterSection></FooterSection>
    </main>
  );
};

export default IndexPage;
